// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2msSB","requiredAsterisk":"Info_requiredAsterisk__2VOx6"};